import React from 'react';

function Header(){
    return(
        <header className ='header'>
            <h1 className='name'>John Conway</h1>
            <p>and</p>
            <h1>The Game of Life</h1>
        </header>
    )
}
export default Header;